import PropTypes from "prop-types";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Skeleton,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ClearIcon from "@mui/icons-material/Clear";
import { error, success, warning } from "src/theme/colors";

export const OverviewPublicWQIStatus = (props) => {
  const { status = {}, isLoading } = props;

  return (
    <Card>
      <CardContent
        sx={{
          pt: 2,
          pb: "16px !important",
        }}
      >
        <Stack
          direction={"column"}
          spacing={2}
        >
          <Stack
            direction="row"
            spacing={2}
            sx={{ alignItems: "center" }}
          >
            <Box
              sx={{
                p: 1,
                width: 48,
                height: 48,
                borderRadius: 1,
                backgroundColor: success.lightest,
              }}
            >
              <SvgIcon
                sx={{
                  width: 32,
                  height: 32,
                  color: success.main,
                }}
              >
                <CheckIcon />
              </SvgIcon>
            </Box>
            <Box sx={{ flex: "1 1 auto" }}>
              <Typography
                color="text.secondary"
                variant="body2"
              >
                Bersih
              </Typography>
              {isLoading ? (
                <Skeleton
                  variant="text"
                  width={80}
                ></Skeleton>
              ) : (
                <Typography variant="h4">{status?.normal.count}</Typography>
              )}
            </Box>
          </Stack>
          <Divider />
          <Stack
            direction="row"
            spacing={2}
            sx={{ alignItems: "center" }}
          >
            <Box
              sx={{
                p: 1,
                width: 48,
                height: 48,
                borderRadius: 1,
                backgroundColor: warning.lightest,
              }}
            >
              <SvgIcon
                sx={{
                  width: 32,
                  height: 32,
                  color: warning.main,
                }}
              >
                <WarningAmberIcon />
              </SvgIcon>
            </Box>
            <Box sx={{ flex: "1 1 auto" }}>
              <Typography
                color="text.secondary"
                variant="body2"
              >
                Sedikit Tercemar
              </Typography>
              {isLoading ? (
                <Skeleton
                  variant="text"
                  width={80}
                ></Skeleton>
              ) : (
                <Typography variant="h4">{status?.warning.count}</Typography>
              )}
            </Box>
          </Stack>
          <Divider />
          <Stack
            direction="row"
            spacing={2}
            sx={{ alignItems: "center" }}
          >
            <Box
              sx={{
                p: 1,
                width: 48,
                height: 48,
                borderRadius: 1,
                backgroundColor: error.lightest,
              }}
            >
              <SvgIcon
                sx={{
                  width: 32,
                  height: 32,
                  color: error.main,
                }}
              >
                <ClearIcon />
              </SvgIcon>
            </Box>
            <Box sx={{ flex: "1 1 auto" }}>
              <Typography
                color="text.secondary"
                variant="body2"
              >
                Tercemar
              </Typography>
              {isLoading ? (
                <Skeleton
                  variant="text"
                  width={80}
                ></Skeleton>
              ) : (
                <Typography variant="h4">{status?.critical.count}</Typography>
              )}
            </Box>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

OverviewPublicWQIStatus.propTypes = {
  status: PropTypes.object,
  isLoading: PropTypes.bool,
};
